export default __webpack_public_path__ + "static/media/double_tag_green.7e55296b.svg";